export default __webpack_public_path__ + "static/media/notifications-empty-dark.add2e69e.png";